import { Offcanvas } from "react-bootstrap";
import "./Notifications.css";
import Common_Back_Btn from "../../../common/common_components/common_back_btn/Common_Back_Btn";

function Notifications({ show, handleClose }) {
  return (
    <>
      <Offcanvas
        className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
        show={show}
        placement="end"
        onHide={handleClose}
      >
        <Offcanvas.Header>
          <Offcanvas.Title>
            <div className="back_div" onClick={handleClose}>
              <Common_Back_Btn />
            </div>
            Notifications
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div className="Notifications_list_holder">
            <div className="notification_card_hodler active">
              <p>
                Your request has been received. We will notify you once it’s
                processed
              </p>
            </div>

            <div className="notification_card_hodler active">
              <p>
                Your request has been received. We will notify you once it’s
                processed
              </p>
            </div>
            <div className="date_holder_box">
              <div className="date_holder">
                <p>12 JAN 2025</p>
              </div>
            </div>

            <div className="notification_card_hodler">
              <p>
                Your request has been received. We will notify you once it’s
                processed
              </p>
            </div>

            <div className="notification_card_hodler">
              <p>
                Your request has been received. We will notify you once it’s
                processed
              </p>
            </div>
            
            <div className="notification_card_hodler">
              <p>
                Your request has been received. We will notify you once it’s
                processed
              </p>
            </div>

            <div className="notification_card_hodler">
              <p>
                Your request has been received. We will notify you once it’s
                processed
              </p>
            </div>
            
            <div className="notification_card_hodler">
              <p>
                Your request has been received. We will notify you once it’s
                processed
              </p>
            </div>

            <div className="notification_card_hodler">
              <p>
                Your request has been received. We will notify you once it’s
                processed
              </p>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default Notifications;
